import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import AddOrderForm from "../../../UI/Orders/add";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

const AddOrderByServicePanel = () => {
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [isPanelsLoading, setIsPanelsLoading] = useState(true);
  const [isUsersLoading, setUsersLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [panels, setPanels] = useState([]);
  const [users, setUsers] = useState([]);

  const getServices = async () => {
    setIsServicesLoading(true);
    const { response } = await Helper.Get({
      url: api_Routes.Services.View,
      hasToken: true,
    });
    if (response) {
      setServices(response?.data);
    }
    setIsServicesLoading(false);
  };

  const getPanels = async () => {
    setIsPanelsLoading(true);
    const { response } = await Helper.Get({
      url: api_Routes.Groups.PanelViewByReseller,
      hasToken: true,
    });
    if (response) {
      setPanels(response);
    }
    setIsPanelsLoading(false);
  };

  const getUsers = async () => {
    setUsersLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.Users.ViewAllByReseller}`,
      hasToken: true,
    });
    if (response) {
      setUsers(response?.data);
    }
    setUsersLoading(false);
  };

  useEffect(() => {
    getServices();
    getPanels();
    getUsers();
  }, []);

  return (
    <div>
      <PanelHead title="Add order" />
      <PanelBody
        content={
          <AddOrderForm
            services={services}
            isServicesLoading={isServicesLoading}
            panels={panels}
            isPanelsLoading={isPanelsLoading}
            users={users}
            isUsersLoading={isUsersLoading}
          />
        }
      />
    </div>
  );
};

export default React.memo(AddOrderByServicePanel);
